export const OFFSET = 20;
export const INITIAL_POSITION = {
  x: -1000,
  y: -1000,
};
